import { find, pipe, prop, propEq, propOr } from 'ramda';
import {
  ACCENT_COLOR_TYPE_BY_BONUS,
  BONUSES_TYPES_FOR_IMAGES,
  fundsBonusSystemStates,
  PREWAGER_BONUS_TYPE
} from '../../../constants';

export const normalizeBsBonusDetails = (
  bonus = {},
  currency,
  bonusTmpl = {},
  formattedCurrency
) => {
  const {
    campaignId: bonusTemplateId,
    campaignName,
    status,
    type: types,
    wageredAmount,
    amountForWager,
    bonusAmount,
    activationExpiredAtTimestamp,
    wageringExpiredAtTimestamp,
    triggerSettings,
    bonusType,
    currency: currencyData
  } = bonus;

  const actualBonusCurrency = currencyData.currency || currency;

  const { currencies = [] } = triggerSettings || {};
  const triggerCurrency = currencies.find(
    ({ currency: c }) => c === actualBonusCurrency
  );

  return {
    ...bonus,
    bonusModelId: bonusTemplateId,
    bonusName: campaignName,
    bonusSum: bonusAmount,
    currency: actualBonusCurrency,
    currencyData: {
      ...currencyData,
      formattedCurrency: formattedCurrency || actualBonusCurrency
    },
    outputBetTotal: wageredAmount,
    outputMaxTotal: amountForWager,
    state: status,
    services:
      Array.isArray(types) &&
      types
        .map((type) => type.charAt(0).toUpperCase() + type.slice(1))
        .join(' + '),
    ...([
      fundsBonusSystemStates.POTENTIAL,
      fundsBonusSystemStates.PROPOSED,
      fundsBonusSystemStates.WAGERING,
      fundsBonusSystemStates.SPINNING
    ].includes(status) && {
      maxActivationTime: {
        sec:
          status === fundsBonusSystemStates.PROPOSED ||
          status === fundsBonusSystemStates.POTENTIAL ||
          status === fundsBonusSystemStates.SPINNING
            ? activationExpiredAtTimestamp
            : wageringExpiredAtTimestamp
      }
    }),
    isBsBonus: true, // identify as bonus from Bonus System,
    triggerSettings: {
      currency: triggerCurrency,
      ...triggerSettings
    },
    bonusContentId: pipe(
      propOr([], 'bonusStatesDescriptions'),
      find(propEq(status, 'state')),
      prop('snippetId')
    )(bonusTmpl),
    imageColorAccent:
      bonusType === PREWAGER_BONUS_TYPE
        ? ACCENT_COLOR_TYPE_BY_BONUS[BONUSES_TYPES_FOR_IMAGES.BS_PWB_BONUS]
        : ACCENT_COLOR_TYPE_BY_BONUS[BONUSES_TYPES_FOR_IMAGES.BS_PWS_BONUS]
  };
};
